/**
 * Browser tab URLs for Excel workbooks opened from SharePoint / Microsoft 365.
 * Used by Alexandria to decide when to sync sheet rows into Load Building suggestions.
 *
 * Add a prefix here for each tenant/site you support in prod or local dev (scheme + host + `/`).
 * Matching is case-insensitive `startsWith`.
 */

export const TRUSTED_SHAREPOINT_WORKBOOK_URL_PREFIXES: readonly string[] = [
  'https://agilecoldstoragecom.sharepoint.com/',
  'https://deployhr1.sharepoint.com/',
  /** Vektor OneDrive for Business (personal library on deployhr1 tenant). */
  'https://deployhr1-my.sharepoint.com/',
  // Dev tenant allowlist only; Vektor vs Agile routing is in sharepoint/utils/sharepointLoadBuildingDataSourceFromUrl.ts
  'https://78n517-my.sharepoint.com/',
];

export function isTrustedSharepointWorkbookUrlPrefix(url: string): boolean {
  const normalized = url.trim().toLowerCase();
  if (!normalized) return false;
  return TRUSTED_SHAREPOINT_WORKBOOK_URL_PREFIXES.some((prefix) =>
    normalized.startsWith(prefix.toLowerCase())
  );
}

/** Alias for Load Building: only trusted workbook tab URLs (see prefix list). */
export function isSharepointExcelWorkbookTabUrl(url: string): boolean {
  return isTrustedSharepointWorkbookUrlPrefix(url);
}
